


























import { computed, defineComponent, onMounted, ref, ssrRef, useFetch, useContext, watch, reactive, toRefs, useRoute } from '@nuxtjs/composition-api';
import { CacheTagPrefix, useCache } from '@vue-storefront/cache';
import { usePageResolver } from '~/stores/page';
import { extendProductsForBox, getProfessioniParentCategory, getTopicsParentCategory } from '~/utils/solepro/products';
import Spinner from '~/components/solepro/Spinner.vue';

import CategoryInfos from '~/components/solepro/Category/CategoryInfos.vue';
import CategoryProductList from '~/components/solepro/Category/CategoryProductList.vue';

import {
  useCategory,
  useConfig,
  useContent,
  useFacet,
  useUiHelpers,
  useUiState,
} from '~/composables';

import facetGetters from '~/modules/catalog/category/getters/facetGetters';

import { usePrice } from '~/modules/catalog/pricing/usePrice';

//import { useCategoryContent } from '~/modules/catalog/category/components/cms/useCategoryContent';
import { useTraverseCategory } from '~/modules/catalog/category/helpers/useTraverseCategory';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { categoryView, categoryProductCardTrack, categoryNavigationTrack } from '~/helpers/trackings/24orepro/categories';
import { getProductFilterByCategoryCommand } from '~/modules/catalog/category/components/filters/command/getProductFilterByCategoryCommand';
import { useApi } from '~/composables/useApi';
import { createProductAttributeFilterInput } from '~/modules/catalog/category/composables/useFacet/input/createProductAttributeFilterInput';
import { isFilterEnabled, isFilterEnabledInCategory } from '~/modules/catalog/category/config/FiltersConfig';
import HTMLContent from '~/components/solepro/HTMLContent.vue';

import type { SortingOptionsValuesEnum } from '~/modules/catalog/category/composables/useFacet/sortingOptions';
import type { Pagination } from '~/composables/types';
import { LOGO } from '~/utils/constants/layout';
import { CATEGORIES_TO_REDIRECT } from '~/utils/constants/solepro/categories';
import useLoader from '~/composables/useLoader';
import axios from 'axios';
import { appendStylesFromText, getAxiosConfigs } from '~/utils/solepro/functions';
import { getAsJSON } from '~/utils/solepro/CmsComponentAggregator';
import usePricesForBox from '~/composables/usePricesForBox';
import CategoryLinks from '~/components/CategoryLinks.vue';


export default defineComponent({
  name: 'CategoryPage',
  components: {
    CategoryInfos,
    HTMLContent,
    CategoryProductGrid: () => import('~/modules/catalog/category/components/views/CategoryProductGrid.vue'),
    CategoryProductList,
    Spinner,
    CategoryLinks
  },
  transition: 'fade',
  props: {
    categoryName: {
      type: String,
      required: false
    },
    preselectedSort: {
      type: String,
      required: false
    }
  },
  setup(props) {

    const state = reactive({
      sortBy: { selected: props.preselectedSort ?? 'position_ASC', options: [] },
      categoryTitle: props.categoryName || '',
      products: [],
      filters: [],
      totalResults: 0,
      pagination: {} as Pagination,
      filterCategory: null,
      allCategories: [],
      categoryMeta: null,
      isInRedirectCategories: false,
      footerDescription: '',
      metaDescription: '',
      metaKeywords: '',
      metaTitle: '',
      shortDescription: '',
      footerStyles: '',
      activeCategoryUid: '',
      activeCategoryName: '',
      relatedFilterCode: '',
      activeCategoryDescription: '',
      activeCategoryUrlPath: '',
      firstEditorialBox: '',
      secondEditorialBox: '',
      firstEditorialBoxPosition: 4,
      secondEditorialBoxPosition: 10,
      categoryFacetId: null,
      urlKeys: {},
      filterCategoryFilterOptions: [],
      filterQP: null,
      isNoIndex: false
    })

    const { resolveUrl } = usePageResolver();
    const route = useRoute()
    //const { getContentData } = useCategoryContent();
    const { loadCategoryMeta } = useCategory();
    const { addTags } = useCache();
    const { query } = useApi();
    const uiHelpers = useUiHelpers();
    const ctx = useContext()
    const { app, $config, $vsf, isDev } = ctx;
    const cmsUrl = $vsf.$magento.config.externalCheckout.cmsUrl
    const categoryUid = ref(null);

    const productContainerElement = ref<HTMLElement | null>(null);
    const { loadBlocks } = useContent();
    const { loadPrices, data: pricesData } = usePricesForBox();

    const {
      toggleFilterSidebar,
    } = useUiState();

    const { activeCategory, loadCategoryTree } = useTraverseCategory();
    state.categoryFacetId = activeCategory.value?.id
    const { result, search } = useFacet(app.$config.testingCategories, state.categoryFacetId);

    const { config: storeConfig } = useConfig();
    const { setIsLoading } = useLoader();

    const trackPageView = async (categoryName) => {
      categoryView(categoryName);
    };
    const goToLink = (link, target) => {
      /* if (target == '_blank') {
         window.open(link, target).focus();
       } else {*/
      window.location.href = link
      /*  }*/
    }
    setIsLoading(true);
    watch(activeCategory, (newVal) => {
      if (!newVal) return;
      if (process.client && location && newVal.url_path && CATEGORIES_TO_REDIRECT[newVal.url_path]) {
        const ctr = CATEGORIES_TO_REDIRECT
        goToLink(ctr[newVal.url_path].url, ctr[newVal.url_path].target)
      } else {
        setIsLoading(false);
      }
    }, { immediate: true })
    const facetsFromUrl = uiHelpers.getFacetsFromURL();
    if (props.preselectedSort) {
      facetsFromUrl.sort = props.preselectedSort
    }

    /** @TODO centralizzare */
    const getUrlKeysInternal = (cats: any[]) => (cats || []).reduce((acc, el) => {
      if (el?.url_path) {
        const parts = el.url_path.split('/');
        const key = parts.length > 1 ? parts[1] : parts[0];
        if (key && el.related_filter_value) {
          acc[el.related_filter_value] = `${key}${el.url_suffix || ''}`;
        }
      }
      return acc;
    }, {});


    const { fetch } = useFetch(async () => {
      const routeData = await resolveUrl();
      categoryUid.value = routeData.uid;
      if (route.value.params.filterCategory) {
        try {
          const axiosConfig = getAxiosConfigs(app, storeConfig);
          const { data } = await axios.get(`/sole-api/category/getFilterCategory?urlKey=${route.value.params.filterCategory}`, {
            ...axiosConfig
          });
          state.filterCategory = data;
          state.categoryFacetId = data?.id
        } catch (e) {
          console.error("Errore Axios filterCategory:", e);
        }
      }
      if (!activeCategory.value) await loadCategoryTree();
      state.activeCategoryUid = activeCategory.value?.uid
      state.activeCategoryName = activeCategory.value?.name ?? '';
      state.relatedFilterCode = activeCategory.value?.related_filter_code ?? '';
      state.activeCategoryDescription = state.shortDescription || activeCategory.value?.description || '';
      state.activeCategoryUrlPath = activeCategory.value?.url_path ?? '';
      state.firstEditorialBox = activeCategory.value?.editorial_box_1 ?? '';
      state.secondEditorialBox = activeCategory.value?.editorial_box_2 ?? '';
      state.firstEditorialBoxPosition = activeCategory.value?.editorial_box_1_position ?? 4;
      state.secondEditorialBoxPosition = activeCategory.value?.editorial_box_2_position ?? 10;
      state.categoryTitle = props.categoryName ?? state.activeCategoryName
      state.footerDescription = activeCategory.value?.description_footer


      const categoryStore = useCategoryStore();

      const rawChildren = categoryStore.rawCategories?.items[0].children || [];
      state.allCategories = JSON.parse(JSON.stringify(rawChildren));



      const facetsFromUrl = uiHelpers.getFacetsFromURL();
      if (props.preselectedSort) facetsFromUrl.sort = props.preselectedSort;

      state.categoryTitle = props.categoryName || (state.filterCategory ? `${state.activeCategoryName} per ${state.filterCategory.name}` : state.activeCategoryName);
      const raw = categoryStore.rawCategories?.items[0]?.children || [];
      const cleanCats = JSON.parse(JSON.stringify(raw));

      const profs = getProfessioniParentCategory(cleanCats)?.children;
      const topics = getTopicsParentCategory(cleanCats)?.children;

      // Popoliamo la mappa locale
      const  profKeys = getUrlKeysInternal(profs)
      state.urlKeys = { ...profKeys, ...getUrlKeysInternal(topics) };
      if (state.filterCategory) {
        const facetKey = profKeys[state.filterCategory.related_filter_value] ? 'professioni' : 'tematiche';
        facetsFromUrl.filters = { ...facetsFromUrl.filters, [facetKey]: [String(state.filterCategory.related_filter_value)] };
      }

      const filterQP = createProductAttributeFilterInput(
        { ...facetsFromUrl, category_uid: categoryUid.value },
        false,
        { currentCategoryId: state.categoryFacetId, testingCategories: app.$config.testingCategories, allCategories: state.allCategories }
      );
      state.filterQP = filterQP

      const [categoryMetaData] = await Promise.all([
        loadCategoryMeta({ category_uid: categoryUid.value }),
        search({ ...facetsFromUrl, category_uid: categoryUid.value, sort: props.preselectedSort || '' })
      ]);
      state.categoryMeta = categoryMetaData;

      const fetchedFilters = await getProductFilterByCategoryCommand.execute(filterQP, query);
      const currentFilters = getCurrentFilters(fetchedFilters);

      if (state.filterCategory) {
        const facetKey = profKeys[state.filterCategory.related_filter_value] ? 'professioni' : 'tematiche';
        state.filters = currentFilters.filter(el => el.attribute_code !== facetKey);
      } else {
        state.filters = currentFilters;
      }
      state.categoryMeta = categoryMetaData;
      state.products = extendProductsForBox(state.allCategories, facetGetters.getProducts(result.value), facetsFromUrl.filters?.tematiche) || [];
      state.totalResults = result.value?.data?.total || 0;
      state.pagination = facetGetters.getPagination(result.value);
      state.sortBy = props.preselectedSort ? { selected: props.preselectedSort, options: [{ label: 'Custom Filter', value: props.preselectedSort as SortingOptionsValuesEnum }] } : facetGetters.getSortOptions(result.value);

      if (route.value.params.filterCategory) {
        const identifier = `solepro_custom_plp_${activeCategory.value.url_path.replace('prodotti/', '')}_${route.value.params.filterCategory}`;
        try {
          const blocks = await loadBlocks({ identifiers: [identifier] });
          const mainBlock = blocks?.find(b => b?.identifier === identifier);
          state.isNoIndex = !mainBlock?.content;

          if (mainBlock?.content) {
            const json = getAsJSON(mainBlock.content, false, isDev, false, cmsUrl);
            const children = json?.children || [];
            const footerBlock = children.find(c => c.cssClasses?.includes('footer_block'));
            const metaBlock = children.find(c => !c.cssClasses?.includes('footer_block'));

            state.footerDescription = footerBlock?.DOMContent?.outerHTML || '';
            state.footerStyles = json?.pageBuilderStyleNode || '';
            state.shortDescription = metaBlock?.children?.find(c => c.cssClasses?.includes('short_description'))?.DOMContent?.textContent || '';
            state.metaDescription = metaBlock?.children?.find(c => c.cssClasses?.includes('meta_description'))?.DOMContent?.textContent || '';
            state.metaKeywords = metaBlock?.children?.find(c => c.cssClasses?.includes('main_keywords'))?.DOMContent?.textContent || '';
            state.metaTitle = metaBlock?.children?.find(c => c.cssClasses?.includes('meta_title'))?.DOMContent?.textContent || state.categoryTitle;
            state.categoryTitle = metaBlock?.children?.find(c => c.cssClasses?.includes('h1_title'))?.DOMContent?.textContent || state.categoryTitle;
            state.activeCategoryDescription = state.shortDescription || activeCategory.value?.description || '';
            state.activeCategoryUrlPath = activeCategory.value?.url_path ?? '';
            /** @TODO change title: get from H1 in cms block */

          }
        } catch (e) {
          console.error("Errore PageBuilder Parsing:", e);
          state.isNoIndex = true;
        }
      }


      const tags = [{ prefix: CacheTagPrefix.View, value: categoryUid.value }];
      const productTags = state.products.map((product) => ({
        prefix: CacheTagPrefix.Product,
        value: product.uid,
      }));

      addTags([...tags, ...productTags]);
      (app.$vsf.$magento.config.state as any).setCategory(categoryUid.value);
    });


    onMounted(async () => {
      if (state.footerStyles) appendStylesFromText(state.footerStyles);
      trackPageView(state.activeCategoryName);
      const { getPricesBySku } = usePrice();
      if (state.products.length > 0) {
        const skus = state.products.map((item) => item.sku);
        const priceData = await getPricesBySku(skus, state.pagination.itemsPerPage);
        state.products = state.products.map((product) => {
          const priceRange = priceData.items.find((item) => item.sku === product.sku)?.price_range;

          if (priceRange) {
            return {
              ...product,
              price_range: priceRange,
            };
          }

          return { ...product };
        });
      }

    });

    watch(() => state.products, (products) => {
        if (!products?.length) return;
        const skus = products.map(p => p.sku);
        loadPrices(skus);
      },
      { immediate: true }
    );

    const goToPage = (page: number) => {

      if (page != 0) {
        categoryNavigationTrack(state.activeCategoryName, page)
      }

      uiHelpers.changePage(page, false);
      fetch();
      productContainerElement.value.scrollIntoView();
    };

    const doChangeItemsPerPage = (itemsPerPage: number) => {
      uiHelpers.changeItemsPerPage(itemsPerPage, false);
      goToPage(0);
    };

    const getCurrentFilters = (fetchedFilters) => {
      if (!fetchedFilters) return [];
      return fetchedFilters
        .filter((f) => isFilterEnabled(f.attribute_code))
        .filter((f) => isFilterEnabledInCategory(f.enabled_categories, categoryUid.value))
        .filter((f) => f.attribute_code !== state.relatedFilterCode)
        .sort((a, b) => (a.position ?? Infinity) - (b.position ?? Infinity));
    };


    const onReloadProducts = () => {
      goToPage(0);
    };

    const trackCategoryProductCard = (productName) => {
      const categoryName = state.activeCategoryName ? state.activeCategoryName : "search";
      categoryProductCardTrack(categoryName, productName)
    }

    return {
      ...toRefs(state),
      ...uiHelpers,
      toggleFilterSidebar,
      categoryUid,
      trackCategoryProductCard,
      doChangeItemsPerPage,
      productContainerElement,
      onReloadProducts,
      goToPage,
      config: $config,
      pricesData,
      isInRedirectCategories: computed(() => activeCategory.value?.url_path && CATEGORIES_TO_REDIRECT[activeCategory.value.url_path]),
      onChangeSorting: (sort) => { state.sortBy.selected = sort; },
    };
  },
  head() {
    const ProductListItems = (this.products as any).map((product, index) => {
      return {
        "@type": "ListItem",
        "position": index + 1,
        "url": `${this.config.soleproDomain}/24orepro/${product.url_key}${product.url_suffix}`
      }
    })
    return {
      ...getMetaInfo({
        ...(this.categoryMeta as any),
        title: this?.categoryTitle || this.activeCategoryName,
        ...(this.metaTitle ? { meta_title: this.metaTitle } : {} ),
        ...(this.metaKeywords ? { meta_keywords: this.metaKeywords } : {}),
        ...(this.metaDescription ? { meta_description: this.metaDescription } : {})

      }, !!this.isNoIndex, 'category'),
      link: [{
        rel: 'preload',
        as: 'image',
        href: LOGO,
        fetchpriority: 'high'
      }],
      script: [
        {
          hid: 'ld-product-list',
          type: 'application/ld+json',
          json: {
            "@context": "https://schema.org",
            "@type": "ItemList",
            "itemListElement": ProductListItems
          }
        }
      ]
    }
  }
});
